module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_Fullscreen_16"],"path":[{"$":{"d":"M15,15H10V13h3V10h2ZM15,1H10V3h3V6h2ZM3,3H6V1H1V6H3ZM6,13H3V10H1v5H6Z","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_Fullscreen_16.svg
// module id = FKu5
// module chunks = 1